import React, {Component} from 'react';

export default class AREntry extends Component {
  render() {
    const shareUrl = encodeURI(this.props.data.effectUrl);

    return (
      <tr>
        <td><img src={ this.props.data.imageSrc ? `${ this.props.data.imageSrc }` : "/images/scene_placeholder.png"} width="100" height="75" className="App-sceneImage" /></td>
        <td className="mobile-hide">{ this.props.data.city }, { this.props.data.country }</td>
        <td>{ this.props.data.location }</td>
        <td className="mobile-hide"><a href={`${ this.props.data.locationUrl }`} target="_blank" className="button">📍 Map</a></td>
        <td>{ this.props.data.effectUrl ? <a href={`${ this.props.data.effectUrl }`} target="_blank" className="button">🤓 View AR Effect</a> : '🤓 View soon'}</td>
        <td className="mobile-hide"><a href={`https://www.facebook.com/sharer.php?u=${ shareUrl }`} target="_blank"><img src={"/images/fb-share.png"} width="60" height="20" className="fb-share" /></a></td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/arEntry.js